var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageColumns(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.625 1.03125V8.59375H12.7188V1.03125H9.625ZM8.59375 1.03125H5.15625V8.59375H8.59375V1.03125ZM4.125 8.59375V1.03125H1.03125V8.59375H4.125ZM0 0H1.03125H12.7188H13.75V1.03125V8.59375V9.625H12.7188H1.03125H0V8.59375V1.03125V0Z",
    fill: "#3A8FD8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageColumns);
export default __webpack_public_path__ + "static/media/manage-columns.dc309cc79e3fd8f3c99bf6c9c663933d.svg";
export { ForwardRef as ReactComponent };